module.exports = __webpack_public_path__ + "img/fb.1f28a302.png";